import * as callActionsImport from './call'
import * as turnActionsImport from './turn'

// Apparently the following doesn't work:
//      export * as newName from './place';
// So import everything from each file, then re-export.
export const callActions = callActionsImport
export const turnActions = turnActionsImport
